import { useSelector } from "react-redux"
import { VNZSessionImage } from "~/interfaces/entities/VNZSessionImage"
import { vnzSessionImagesSelectors } from "~/redux/state/VNZSessionImages"
import { RootState } from "~/redux/store"

export const useVNZSessionStatus = () => {
  const isProcessing = useSelector(
    (state: RootState) => state.VNZSessionImages.isProcessing
  )
  const hasSessionData = useSelector(
    (state: RootState) => state.VNZSessionImages.hasSessionData
  )
  const hasBeenProcessed = useSelector(
    (state: RootState) => state.VNZSessionImages.hasBeenProcessed
  )
  const hasError = useSelector(
    (state: RootState) => state.VNZSessionImages.hasError
  )
  const imageSessions: VNZSessionImage[] = useSelector((state: RootState) =>
    vnzSessionImagesSelectors.selectAll(state)
  )

  const totalCount = imageSessions.length
  const processedCount = imageSessions.filter(
    image => image.hasBeenProcessed
  ).length
  const processingCount = imageSessions.filter(
    image => image.isProcessing
  ).length
  const processedErrorCount = imageSessions.filter(
    image => image.hasError
  ).length

  return {
    isProcessing,
    hasSessionData,
    hasBeenProcessed,
    hasError,
    imageSessions,
    totalCount,
    processedCount,
    processingCount,
    processedErrorCount,
  }
}
